export default function GetScoreColor(score) {
    if (score === 1) {
        return "text-red";
    } else if (score === 2) {
        return "text-orange";
    } else if (score === 3) {
        return "text-lemon";
    } else if (score === 4) {
        return "text-dirtyGreen";
    } else if (score === 5) {
        return "text-brightGreen";
    } else {
        return "gray-500"
    }
}